import { useState } from 'react';

const newsItems = [
  {
    id: 1,
    category: '복지 정책',
    categoryColor: 'bg-amber-100 text-amber-800',
    title: '2026년 활동지원서비스 단가 인상, 주요 변경 사항 안내',
    excerpt: '보건복지부는 2026년도 장애인 활동지원 급여 단가를 시간당 1만 7천원으로 인상한다고 발표했습니다. 이에 따른 활동지원사 처우 개선 방안을 살펴봅니다.',
    date: '2026.03.20',
    readTime: '5분',
    image: 'https://public.readdy.ai/ai/img_res/b4c2c77a004ba0e0fae41d2b899ab2d1.jpg',
  },
  {
    id: 2,
    category: '국제 뉴스',
    categoryColor: 'bg-green-100 text-green-800',
    title: 'UN 장애인 권리 협약 이행 보고서: 한국의 현황과 과제',
    excerpt: '유엔 장애인권리위원회는 최근 발표한 보고서에서 한국의 장애인 지역사회 통합 서비스 확대를 긍정적으로 평가하면서도 추가 개선이 필요한 영역을 지적했습니다.',
    date: '2026.03.18',
    readTime: '7분',
    image: 'https://readdy.ai/api/search-image?query=United%20Nations%20building%20and%20international%20disability%20rights%20conference%2C%20global%20cooperation%20theme%2C%20professional%20documentary%20style%2C%20warm%20natural%20light%2C%20hope%20and%20progress&width=400&height=260&seq=news002&orientation=landscape',
  },
  {
    id: 3,
    category: '현장 이야기',
    categoryColor: 'bg-rose-100 text-rose-700',
    title: '"처음엔 두려웠지만 지금은 보람이에요" - 10년 차 활동지원사 인터뷰',
    excerpt: '서울에서 10년간 활동지원사로 일해온 최미영 씨의 이야기. 그녀가 경험한 성장과 변화, 그리고 이 일을 통해 발견한 삶의 의미를 들어봅니다.',
    date: '2026.03.15',
    readTime: '8분',
    image: 'https://readdy.ai/api/search-image?query=experienced%20Korean%20caregiver%20woman%20being%20interviewed%20warmly%20smiling%2C%20heartwarming%20portrait%20documentary%20style%2C%20soft%20window%20light%2C%20warm%20cream%20interior%2C%20storytelling%20photography&width=400&height=260&seq=news003&orientation=landscape',
  },
  {
    id: 4,
    category: '교육 정보',
    categoryColor: 'bg-indigo-100 text-indigo-700',
    title: '2026 상반기 활동지원사 보수교육 일정 및 신청 방법',
    excerpt: '국가에서 의무적으로 시행하는 활동지원사 보수교육 일정이 발표되었습니다. 온·오프라인 수강 방법과 이수 기준을 상세히 안내해 드립니다.',
    date: '2026.03.12',
    readTime: '4분',
    image: 'https://readdy.ai/api/search-image?query=Korean%20professional%20education%20and%20training%20announcement%20calendar%20schedule%2C%20organized%20clean%20desk%2C%20warm%20office%20light%2C%20planning%20and%20schedule%20theme&width=400&height=260&seq=news004&orientation=landscape',
  },
  {
    id: 5,
    category: '건강 & 복지',
    categoryColor: 'bg-teal-100 text-teal-700',
    title: '장애인 자립생활 지원 주거서비스, 전국 50개 지역으로 확대',
    excerpt: '정부가 발표한 장애인 탈시설·자립지원 로드맵의 일환으로 자립생활 주거 서비스가 기존 20개에서 50개 지역으로 대폭 확대됩니다.',
    date: '2026.03.10',
    readTime: '6분',
    image: 'https://readdy.ai/api/search-image?query=Korean%20accessible%20housing%20and%20independent%20living%20support%20for%20disabled%20people%2C%20modern%20barrier%20free%20apartment%20interior%2C%20warm%20and%20hopeful%20atmosphere%2C%20independence%20theme&width=400&height=260&seq=news005&orientation=landscape',
  },
  {
    id: 6,
    category: '세계 동향',
    categoryColor: 'bg-orange-100 text-orange-700',
    title: '일본 개호보험 개혁 동향: 한국 활동지원제도에 주는 시사점',
    excerpt: '일본이 2026년 개호보험 대규모 개혁을 추진 중입니다. 선진 복지국가의 변화가 한국 장애인 활동지원 제도 발전에 어떤 시사점을 주는지 분석합니다.',
    date: '2026.03.07',
    readTime: '9분',
    image: 'https://readdy.ai/api/search-image?query=Japan%20Korea%20welfare%20policy%20comparison%20research%20analysis%2C%20international%20social%20welfare%20trends%2C%20professional%20research%20setting%2C%20clean%20warm%20light%2C%20global%20perspective&width=400&height=260&seq=news006&orientation=landscape',
  },
];

export default function NewsSection() {
  const [email, setEmail] = useState('');
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeCategory, setActiveCategory] = useState('전체');

  const categories = ['전체', '복지 정책', '국제 뉴스', '현장 이야기', '교육 정보', '세계 동향'];

  const filtered = activeCategory === '전체'
    ? newsItems
    : newsItems.filter((n) => n.category === activeCategory);

  const handleNewsletter = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const params = new URLSearchParams();
      params.append('email', email);
      await fetch('https://readdy.ai/api/form/d70f4bf9hgr6oot2qu60', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      setNewsletterSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="news" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid lg:grid-cols-3 gap-16 mb-16">
          <div className="lg:col-span-2">
            <div className="inline-flex items-center gap-2 bg-stone-100 text-stone-700 rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
              <i className="ri-newspaper-line text-stone-500"></i>
              NEWS & INFORMATION
            </div>
            <h2 className="text-5xl font-bold text-stone-800 mb-3">
              뉴스와 정보 공유
            </h2>
            <p className="text-stone-500 text-lg">
              국내외 복지 뉴스와 활동지원 관련 최신 정보를 전달합니다.
            </p>
          </div>
          <div className="bg-amber-600 rounded-3xl p-7 text-white">
            {newsletterSubmitted ? (
              <div className="text-center py-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-3">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-bold text-lg mb-1">구독 완료!</h3>
                <p className="text-amber-100 text-sm">매주 최신 복지 뉴스를 보내드릴게요.</p>
              </div>
            ) : (
              <>
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl mb-4">
                  <i className="ri-mail-send-line text-white text-xl"></i>
                </div>
                <h3 className="font-bold text-xl mb-2">뉴스레터 구독</h3>
                <p className="text-amber-100 text-sm leading-relaxed mb-5">
                  매주 월요일, 국내외 복지 뉴스와 활동지원 정보를 이메일로 받아보세요.
                </p>
                <form
                  data-readdy-form
                  onSubmit={handleNewsletter}
                  className="space-y-3"
                >
                  <input
                    name="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="이메일 주소 입력"
                    className="w-full bg-white/20 border border-white/30 rounded-xl px-4 py-3 text-white text-sm placeholder:text-amber-200 focus:outline-none focus:bg-white/30"
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full py-3 bg-white text-amber-700 rounded-xl font-semibold text-sm hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-70"
                  >
                    {submitting ? '처리 중...' : '무료 구독하기'}
                  </button>
                </form>
                <p className="text-amber-200 text-xs mt-3">✓ 언제든지 구독 취소 가능</p>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-stone-800 text-white'
                  : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden hover:border-stone-200 transition-all group cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${item.categoryColor}`}>
                    {item.category}
                  </span>
                  <span className="text-stone-400 text-xs">{item.date}</span>
                  <span className="text-stone-400 text-xs ml-auto">{item.readTime} 읽기</span>
                </div>
                <h3 className="font-bold text-stone-800 text-base leading-snug mb-2 line-clamp-2 group-hover:text-amber-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed line-clamp-2">{item.excerpt}</p>
                <div className="flex items-center gap-1 mt-4 text-amber-600 text-sm font-medium">
                  <span>자세히 읽기</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <button className="px-8 py-3.5 border-2 border-stone-300 text-stone-700 rounded-full font-semibold text-sm hover:border-stone-400 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
            더 많은 뉴스 보기
          </button>
        </div>
      </div>
    </section>
  );
}
